import PropTypes from 'prop-types';

export const discoversAllPT = PropTypes.arrayOf(PropTypes.exact({
  name: PropTypes.string,
  uri_param: PropTypes.string,
}));

